import { branch, compose, renderNothing } from 'recompose';
import { isEmpty } from 'lodash';
import React from 'react';

import WithShop from '../hoc/WithShop';
import { shopShape } from '../shapes';
import { formatPhone } from '../utils/helpers';

const Footer = ({ shop }) => (
  <footer className="u-bg-white">
    <div className="o-wrapper o-wrapper--page">
      <div className="c-footer c-footer--shop u-pt">
        <div className="c-heading c-heading--huge u-co-teal-blue">
          { shop.name }
        </div>
        <div className="c-heading c-heading--large u-mv--">
          { shop.address }
        </div>
        <div className="c-heading c-heading--large">
          { formatPhone(shop.phone) }
        </div>
      </div>
    </div>
  </footer>
);
Footer.propTypes = {
  shop: shopShape,
};
Footer.defaultProps = {
  shop: {},
};

export default compose(
  WithShop,
  branch(
    props => isEmpty(props.shop),
    renderNothing
  )
)(Footer);



// WEBPACK FOOTER //
// ./src/app/components/ShopFooter.jsx